import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Fragment, useState, useEffect } from 'react';
import { Button, Col, Image, Modal, Row } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Alert from 'react-s-alert';
import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox';
import {
  delete_item_from_category,
  get_menu_items,
  update_item_menu_setup,
} from '../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction';
import {
  SET_ACTIVE_ITEM_ID_MENU_SETUP,
  BUSINESS_DETAILS_STEP,
} from '../../../../store/types';
// import OrderLocation from "./OrderLocation";
import { Toggle } from '../../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle';
import Services from '../../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/AddItem/Services';
import EditModelBody from './EditModelBody';
// import CustomSuperAdminNotification from "../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
// import SuperAdminCall from "../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall";
import ItemDescModelBody from './ItemDescModelBody';
import { ITEMTYPEVEG } from '../../../../enums/OrderEnums';
import SVG from 'react-inlinesvg';
import { NOTAVAILABLEIMAGE } from '../../../../enums/GlobalEnums';
import { ReadMore } from '../../../superAdminComponents/superAdminAllComponent/superAdminOffers/SuperAdminOffers';
import moment from 'moment';

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: 'linear',
    overlayColor: 'rgba(0, 0, 0, 0.9)',
    slideAnimationType: 'fade',
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: 'linear',
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const TableBody = (props) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  //Model order view
  const [MrDetail, setMrDetail] = useState({ MrDetail: false });
  const viewOrderInDetail = () => setMrDetail({ MrDetail: !MrDetail.MrDetail });

  const [vtype, viewType] = useState(1);

  const onSuccess = () => {
    props.get_menu_items(props.token);
    handleCloseItemAvaiblity();
  };

  const [activeAvailablity, setActiveAvaiblity] = useState('');

  const availabilityStatus = [
    { name: 'Available', id: 'AVAILABLE', color: 'green' },
    { name: 'SoldOut', id: 'SOLDOUT', color: 'red' },
    { name: 'Not Available', id: 'NOTAVAILABLE', color: 'black' },
  ];

  const onSuccessDelete = () => {
    Alert.success(`<h4>Item Deleted Sucessfully</h4>`, {
      position: 'top-right',
      effect: 'bouncyflip',
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    onSuccess();
  };

  const changeStatus = (status) => {
    const formData = {};
    if (status === undefined) {
      formData.status = false;
    } else {
      formData.status = !status;
    }
    props.update_item_menu_setup(
      props.item._id,
      formData,
      props.token,
      onSuccess
    );
  };

  const changeAutoAccept = (status) => {
    const formData = {};

    formData.auto_accept = !status;

    props.update_item_menu_setup(
      props.item._id,
      formData,
      props.token,
      onSuccess
    );
  };

  const [showItemAvaiblity, setShowItemAvaiblity] = useState(false);
  const handleCloseItemAvaiblity = () => {
    setShowItemAvaiblity(false);
  };
  const handleShowItemAvaiblity = (id) => {
    setActiveAvaiblity(id);
    setShowItemAvaiblity(true);
  };

  const onClickUpdateItemAvaiblity = () => {
    const formData = {};
    formData.availability = activeAvailablity;
    props.update_item_menu_setup(
      props.item._id,
      formData,
      props.token,
      onSuccess
    );
  };

  const [showItem, setShowItem] = useState(false);
  const handleCloseShowItem = () => {
    setShowItem(false);
  };
  const handleshowItem = () => {
    setShowItem(true);
  };

  const onClickDeleteItem = () => {
    props.delete_item_from_category(
      props.item._id,
      props.token,
      onSuccessDelete
    );
  };

  const takeToEditPage = () => {
    dispatch({ type: SET_ACTIVE_ITEM_ID_MENU_SETUP, payload: props.item._id });
    dispatch({ type: BUSINESS_DETAILS_STEP, payload: 3 });
    history.push('/additemavailablity');
  };

  const displayHealthTags = (itemHealthTags, categoryHealthTags) => {
    let result =
      categoryHealthTags &&
      categoryHealthTags.filter(
        (o1) => itemHealthTags && itemHealthTags.some((o2) => o1?._id === o2)
      );
    return result;
  };

  /*****************************
   * @DESC ACTIVE SERVICES
   *****************************/
  const [activeServiceArr, setActiveServiceArr] = useState();

  useEffect(() => {
    let data = [];
    if (props?.subscriptionStatus?.ordering?.take_away?.value) {
      if (props?.item?.take_away?.value) {
        let value = 'Take Away';
        data.push(value);
      }
    }
    if (props?.subscriptionStatus?.ordering?.cubside_delivery?.value) {
      if (props?.item?.curb_side?.value) {
        let value = 'Curb Side';
        data.push(value);
      }
    }
    if (props?.subscriptionStatus?.ordering?.self_serve?.value) {
      if (props?.item?.skip_line?.value) {
        let value = 'Skip The Line';
        data.push(value);
      }
    }
    if (props?.subscriptionStatus?.ordering?.dine_in_order?.value) {
      if (props?.item?.dine_in?.value) {
        let value = 'Dine In';
        data.push(value);
      }
    }
    if (props?.subscriptionStatus?.ordering?.catering_banquet?.value) {
      if (props?.item?.catering_banquet?.value) {
        let value = 'Catering';
        data.push(value);
      }
    }
    if (props?.subscriptionStatus?.ordering?.home_delivery?.value) {
      if (props?.item?.home_delivery?.value) {
        let value = 'Home Delivery';
        data.push(value);
      }
    }
    setActiveServiceArr(data);
  }, [props?.subscriptionStatus, props?.item]);

  let activeServiceText =
    activeServiceArr && activeServiceArr.toString().replace(/,/gi, ', ');

  return (
    <React.Fragment>
      <tbody
        className="w-100 super-admin-all-vendor-main-table-body"
        style={{ fontSize: '12px' }}
      >
        {/* <tr className="w-100 p-0">
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css"> */}
        <tr
          className="sd_body_table-row px-3"
          // style={{ textAlign: "center" }}
          onClick={showTr}
        >
          <td
            style={{ width: '15%' }}
            onClick={(e) => {
              if (!e) var e = window.event;
              e.cancelBubble = true;
              if (e.stopPropagation) e.stopPropagation();
            }}
          >
            <p className="text-break f12-500 mb-2">
              #ID:
              {props?.item?.ext_id ? props?.item?.ext_id : props?.item?._id}
            </p>
            <SimpleReactLightbox>
              <SRLWrapper options={options}>
                {props &&
                props?.item &&
                props?.item?.image_thumbnails &&
                props?.item?.image_thumbnails?.[0] ? (
                  <Image
                    src={
                      props && props?.item && props.item.image_thumbnails?.[0]
                    }
                    style={{
                      width: '42px',
                      height: '42px',
                      borderRadius: '5px',
                    }}
                    alt={props && props?.item && props?.item?.name}
                    title={props && props?.item && props?.item?.name}
                  />
                ) : props && props?.item && props?.item?.images?.[0] ? (
                  <Image
                    src={props && props?.item && props?.item?.images?.[0]}
                    style={{
                      width: '42px',
                      height: '42px',
                      borderRadius: '5px',
                    }}
                    alt={props && props?.item && props?.item?.name}
                    title={props && props?.item && props?.item?.name}
                  />
                ) : (
                  <Image
                    src={NOTAVAILABLEIMAGE}
                    style={{
                      width: '42px',
                      height: '42px',
                      borderRadius: '5px',
                    }}
                    alt={'Item pic'}
                    title={
                      (props && props?.item && props?.item?.name) || 'Item pic'
                    }
                  />
                )}
              </SRLWrapper>
            </SimpleReactLightbox>
          </td>
          <td style={{ width: '15%' }}>
            <div className="d-flex">
              {ITEMTYPEVEG.map((type, index) => {
                return (
                  <React.Fragment key={index}>
                    {props?.item?.itemType === type?.value ? (
                      <img
                        width="20px"
                        height="20px"
                        src={type.url}
                        alt={type.title}
                        title={type.title}
                        fluid
                      />
                    ) : null}
                  </React.Fragment>
                );
              })}
              <p className="text-break f12-500 ml-2">
                {props && props?.item && props?.item?.name}
              </p>
            </div>
            <hr className="my-3 m-0" />
            <div className="d-flex">
              <Image
                src={
                  props &&
                  props?.item &&
                  props?.item?.primary_food_type &&
                  props?.item?.primary_food_type?.icon
                }
                alt={
                  props &&
                  props?.item &&
                  props?.item?.primary_food_type &&
                  props?.item?.primary_food_type?.title
                }
                title={
                  props &&
                  props?.item &&
                  props?.item?.primary_food_type &&
                  props?.item?.primary_food_type?.title
                }
                width="20px"
                fluid
              />{' '}
              <p className="text-break f12-500 ml-2">
                {props &&
                  props?.item &&
                  props?.item?.primary_food_type &&
                  props?.item?.primary_food_type?.title}
              </p>
            </div>
          </td>
          <td className="text-center" style={{ width: '20%' }}>
            <p className="text-break f12-500">
              {props &&
                props.item &&
                props.item.category &&
                props.item.category.name}
            </p>
          </td>
          <td style={{ width: '18%' }} className="d-flex">
            <p className="text-break f12-500">
              {props && props.item && props.item.prepTime} Mins
            </p>
            {/* All Day &nbsp;
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      onClick={(e) => {
                        if (!e) var e = window.event;
                        e.cancelBubble = true;
                        if (e.stopPropagation) e.stopPropagation();
                        viewType(1);
                        viewOrderInDetail();
                      }}
                    >
                      <Image
                        src={require("../../../../assets/images/UserManagement/pencil.svg")}
                        alt="Edit"
                        title="Edit"
                        fluid
                      />
                    </Button>{" "} */}
          </td>
          <td
            style={{ width: '17%' }}
            onClick={(e) => {
              if (!e) var e = window.event;
              e.cancelBubble = true;
              if (e.stopPropagation) e.stopPropagation();
            }}
          >
            <div className="d-flex align-items-center">
              <div className="f12-500 mr-1">
                {!props.item.status ? 'Inactive' : 'Active'}
              </div>
              <Toggle
                // checked={props.item && props.item.auto_accept}
                // toggleFunction={() => changeAutoAccept(props.item.auto_accept)}
                checked={
                  props.item && props.item.status === undefined
                    ? true
                    : props.item && props.item.status
                    ? true
                    : false
                }
                toggleFunction={() => changeStatus(props.item.status)}
                className="tog_mv"
              />
            </div>
          </td>
          <td
            style={{ width: '15%' }}
            onClick={(e) => {
              if (!e) var e = window.event;
              e.cancelBubble = true;
              if (e.stopPropagation) e.stopPropagation();
            }}
          >
            <div
              onClick={() => handleShowItemAvaiblity(props.item.availability)}
              //className="badge badge-danger"
              id="mobile_view_badge"
              className={`${
                props && props.item && props.item.availability === 'AVAILABLE'
                  ? 'badge badge-success f9-500 text-white'
                  : props && props.item && props.item.availability === 'SOLDOUT'
                  ? 'badge badge-danger f9-500 text-white'
                  : 'badge badge-dark f9-500 text-white'
              }`}
              style={{ padding: '8px 20px', borderRadius: '15px' }}
            >
              {props && props?.item && props?.item?.availability}
            </div>
          </td>
        </tr>
        {TrDetail.TrDetail && (
          <tr className="sd_accordion_body" style={{ background: '#ffffff' }}>
            <div className="container-fluid">
              <hr style={{ margin: 0 }} />
              <div className="row mt-3" style={{ alignItems: 'flex-start' }}>
                <div
                  className="col-2"
                  style={{ borderRight: '1px solid #E0E0E0' }}
                >
                  <h6 className="f12-500 mb-3">More actions</h6>
                  <div className="more-actions-orders-desc d-flex align-items-center justify-content-end mb-2">
                    {/* <SuperAdminCall /> */}
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      onClick={() => {
                        viewType(1);
                        viewOrderInDetail();
                      }}
                    >
                      <Image
                        src={require('../../../../assets/images/UserManagement/eye.svg')}
                        alt="View"
                        title="View"
                        fluid
                      />
                    </Button>
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      // onClick={() => {
                      //   viewType(2);
                      //   viewOrderInDetail();
                      // }}
                      onClick={() => takeToEditPage()}
                    >
                      <Image
                        src={require('../../../../assets/images/UserManagement/pencil.svg')}
                        alt="Edit"
                        title="Edit"
                        fluid
                      />
                    </Button>{' '}
                    <Button
                      variant="link"
                      className="enIconBtn mr-3"
                      onClick={() => handleshowItem()}
                      // onClick={() => {
                      //   viewType(1);
                      //   viewOrderInDetail();
                      // }}
                    >
                      <Image
                        src={require('../../../../assets/images/UserManagement/Delete.svg')}
                        alt="Delete"
                        title="Delete"
                        fluid
                      />
                      {/* <i
                                class="fa fa-trash"
                                style={{ color: "#000000" }}
                                title="Delete"
                              ></i> */}
                    </Button>
                    {/* <CustomSuperAdminNotification
                              _id={"5f84b0d7741561060859ee1f"}
                            /> */}
                  </div>
                </div>
                <div className="col-2">
                  <h6 className="f12-500 mb-3">Active Services</h6>
                  <p className="d-flex f11-500" style={{ color: '#1396ff' }}>
                    {activeServiceText && activeServiceText}
                  </p>
                </div>
                <div className="col-3">
                  <h6 className="f12-500 mb-3">Description</h6>
                  <p className="f11-500">
                    <ReadMore
                      children={props?.item?.description}
                      minLength={30}
                      charLength={
                        props?.item?.description !== null &&
                        props?.item?.description !== undefined
                          ? props?.item?.description.length
                          : 10
                      }
                    />
                  </p>
                </div>
                {/* <div className="col-1">
                  <h6 className="f12-500 mb-3">Status</h6>
                  <p className="f10-500 d-flex align-items-center">
                    {props.item && props.item.status === undefined
                      ? "Active"
                      : props.item && props.item.status
                      ? "Active"
                      : "In Active"}
                    &nbsp;
                    <Toggle
                      checked={
                        props.item && props.item.status === undefined
                          ? true
                          : props.item && props.item.status
                          ? true
                          : false
                      }
                      toggleFunction={() => changeStatus(props.item.status)}
                    />
                  </p>
                </div> */}
                <div className="col-3">
                  <Row>
                    <div className="col">
                      <h6 className="f12-500 mb-3">Item Tag</h6>
                      <p className="f11-500">
                        {props &&
                          props.item &&
                          props.item.tags &&
                          props.item.tags.map((tag, index) => (
                            <Fragment key={index}>
                              {' '}
                              {tag.title}{' '}
                              {index + 1 !== props.item.tags.length && ', '}
                            </Fragment>
                          ))}
                      </p>
                    </div>
                    <div className="col">
                      <h6 className="f12-500 mb-3">Health Tag</h6>
                      <p className="f11-500">
                        {displayHealthTags &&
                          displayHealthTags(
                            props?.item?.healthTags,
                            props?.healthTags
                          ).map((tag, index) => {
                            return (
                              <Fragment key={index}>
                                {tag.title}
                                {index + 1 !== props?.item?.healthTags.length &&
                                  ', '}
                              </Fragment>
                            );
                          })}
                      </p>
                    </div>
                  </Row>
                </div>
                <div className="col-2">
                  <h6 className="f12-500 mb-3">Cuisine Type</h6>
                  <p className="f11-500">
                    {props &&
                      props.item &&
                      props.item.cuisin_type &&
                      props.item.cuisin_type.title}
                  </p>
                </div>
              </div>
              <hr />
              <Row>
                <Col md={6} style={{ borderRight: '1px solid #E0E0E0' }}>
                  <h6 className="f12-500">Item sizes</h6>
                  <table className="table desc-order-info">
                    <thead>
                      <tr
                        style={{
                          backgroundColor: 'transparent',
                        }}
                      >
                        <th className="f11-500" style={{ width: '25%' }}>
                          Available
                        </th>
                        <th className="f11-500" style={{ width: '25%' }}>
                          Size
                        </th>
                        <th className="f11-500" style={{ width: '25%' }}>
                          Price
                        </th>
                        <th className="f11-500" style={{ width: '25%' }}>
                          Serving PAX
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {props &&
                        props.item &&
                        props.item.size.map((size, index) => (
                          <tr key={index}>
                            <td style={{ width: '25%' }}>
                              <Toggle
                                checked={size.available}
                                //checked={false}
                                disabled={true}
                              />
                            </td>
                            <td style={{ width: '25%' }}>
                              <ReadMore
                                children={size?.description}
                                minLength={30}
                                charLength={
                                  size?.description !== null &&
                                  size?.description !== undefined
                                    ? size?.description.length
                                    : 10
                                }
                              />
                            </td>
                            <td style={{ width: '25%' }}>₹ {size.price}</td>
                            <td style={{ width: '25%' }}>{size.pax}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </Col>
                <Col
                  md={2}
                  style={{
                    paddingTop: '50px',
                    borderRight: '1px solid #E0E0E0',
                  }}
                >
                  <h6 className="f12-500 mb-3">Customizable</h6>
                  <p className="f11-500" style={{ color: '#1396FF' }}>
                    {props &&
                      props.item &&
                      props.item.addOns &&
                      props.item.addOns.map((addon, index) => (
                        <Fragment key={index}>{addon.name} </Fragment>
                      ))}
                  </p>
                </Col>
                <Col md={2} style={{ paddingTop: '50px' }}>
                  <h6 className="f12-500 mb-3">No. Of Views</h6>
                  <p className="f11-500">
                    <Image
                      src={require('../../../../assets/images/UserManagement/eye.svg')}
                      alt="View"
                      title="View"
                      fluid
                      style={{ paddingRight: '3px' }}
                    />
                    {props && props.item && props.item.view_count}
                  </p>
                </Col>
                <Col md={2} style={{ paddingTop: '50px' }}>
                  <h6 className="f12-500 mb-3">Item Ordered</h6>
                  <div className="f11-500 d-flex align-items-center">
                    <Image
                      src={require('../../../../assets/images/Orders/icons/itemOrders.svg')}
                      alt="Item Ordered"
                      title="Item Ordered"
                      style={{
                        paddingRight: '3px',
                        width: '18px',
                        // maxWidth: "100%",
                        height: 'auto',
                      }}
                    />
                    <p>{props && props.item && props.item.order_count}</p>
                  </div>
                </Col>
              </Row>
              <hr />

              <div className="row mt-3" style={{ alignItems: 'flex-start' }}>
                {props?.item?.date_of_availability?.start_date && (
                  <>
                    <div className="col-4">
                      <h6 className="f12-500 mb-3">Date of Availability</h6>
                      <div className="d-flex">
                        <div className="f12-500">
                          {moment(
                            props?.item?.date_of_availability?.start_date
                          ).format('Do MMM YYYY')}
                        </div>
                        <span className="mx-2"> to </span>
                        <div className="f12-500">
                          {moment(
                            props?.item?.date_of_availability?.end_date
                          ).format('Do MMM YYYY')}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* <div className="col-1">
                  <h6 className="f12-500 mb-3">Status</h6>
                  <p className="f10-500 d-flex align-items-center">
                    {props.item && props.item.status === undefined
                      ? "Active"
                      : props.item && props.item.status
                      ? "Active"
                      : "In Active"}
                    &nbsp;
                    <Toggle
                      checked={
                        props.item && props.item.status === undefined
                          ? true
                          : props.item && props.item.status
                          ? true
                          : false
                      }
                      toggleFunction={() => changeStatus(props.item.status)}
                    />
                  </p>
                </div> */}
                <div className="col-3">
                  <Row>
                    {props?.item?.lead_time && (
                      <div className="col">
                        <h6 className="f12-500 mb-3">Lead Time</h6>
                        <div className="f11-500">
                          {props?.item?.lead_time} {'Mins'}
                        </div>
                      </div>
                    )}
                    {props?.item?.cut_off_time && (
                      <>
                        <div className="col">
                          <h6 className="f12-500 mb-3">Cutoff Time</h6>
                          <div className="f11-500">
                            {props?.item?.cut_off_time} {'Mins'}
                          </div>
                        </div>
                      </>
                    )}
                  </Row>
                </div>
              </div>
            </div>
          </tr>
        )}
        <div>
          <Modal
            show={MrDetail.MrDetail}
            onHide={() => {
              viewOrderInDetail();
            }}
            centered
            size="lg"
          >
            <Modal.Header className="border-0 pl-4" closeButton>
              <Modal.Title className="f24-700">
                Item Availability Details
                {/* {vtype === 2 && "Substitute Item"}
                        // {vtype === 3 && "User Location"} */}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4 f16-500">
              <div className="">
                {vtype === 1 && (
                  <ItemDescModelBody
                    takeToEditPage={takeToEditPage}
                    handleshowItem={handleshowItem}
                    item={props && props.item}
                  />
                )}
                {vtype !== 3 && vtype !== 1 && <EditModelBody />}
                {vtype === 3 && (
                  <div className="new-subscription-onboarding-component">
                    <Row>
                      <Col xs={8}>
                        <TextField
                          variant="outlined"
                          label="Item Name"
                          fullWidth
                        />
                      </Col>
                    </Row>
                    <Services onChange={() => {}} origin={'edit'} />
                  </div>
                )}

                {/* {vtype === 3 && <OrderLocation />} */}
              </div>
              {/* <EditUser
                            data={currentUserData}
                            CloseEdit={handleCloseEdit}
                          /> */}
            </Modal.Body>
          </Modal>
        </div>
        {/* </tbody>
            </table>
          </td>
        </tr> */}
      </tbody>
      <React.Fragment>
        <Modal show={showItem} onHide={handleCloseShowItem} centered>
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            Are you sure to delete this Item ?
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={handleCloseShowItem}
            >
              No
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              // onClick={handleCloseBlockUser}
              onClick={() => onClickDeleteItem()}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>

      <React.Fragment>
        <Modal
          show={showItemAvaiblity}
          onHide={handleCloseItemAvaiblity}
          centered
        >
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title> Availability Status</Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            {' '}
            Select one relevant options from below
            <div className="container">
              <div className="row ">
                {availabilityStatus.map((availablity, index) => (
                  <div className="col-4 p-2" key={index}>
                    <div
                      className={` p-2 ${
                        availablity.id === activeAvailablity &&
                        `sts_sld_btn_box_a`
                      }`}
                      onClick={() => setActiveAvaiblity(availablity.id)}
                      style={{
                        backgroundColor: `${availablity.color}`,
                        borderRadius: '5px',
                        color: 'white',
                      }}
                      align="center"
                      type="button"
                    >
                      {availablity.name}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={handleCloseItemAvaiblity}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              // onClick={handleCloseBlockUser}
              onClick={() => onClickUpdateItemAvaiblity()}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    </React.Fragment>
  );
};

TableBody.propTypes = {
  auth: PropTypes.object.isRequired,
  update_item_menu_setup: PropTypes.func.isRequired,
  get_menu_items: PropTypes.func.isRequired,
  delete_item_from_category: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  allergy_info: state.category && state.category.allergy_info,
  menuCategoryItems: state.onboarding && state.onboarding.menuCategoryItems,
  activeItemId: state.onboarding && state.onboarding.activeItemId,
  healthTags: state.category && state.category.health_tags,
  subscriptionStatus: state?.onboarding?.onboard_subscription_details
    ?.casual_dining
    ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining
    ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
    : state?.onboarding?.onboard_subscription_details?.multi_service_business
    ? state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status
    : {},
});

export default connect(mapStateToProps, {
  update_item_menu_setup,
  get_menu_items,
  delete_item_from_category,
})(TableBody);
